import { c as _c } from "react/compiler-runtime";
import MyStreamActionTooltip from "@/components/brain/my-stream/MyStreamActionTooltip";
import { Spinner } from "@/components/dotLoader/DotLoader";
import { faBellSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { WaveNotificationSettingsState } from "./useWaveNotificationSettings";
interface WaveMutedNotificationButtonProps {
  readonly waveId: string;
  readonly settings: WaveNotificationSettingsState;
  readonly compact?: boolean | undefined;
}
export default function WaveMutedNotificationButton(t0) {
  const $ = _c(16);
  const {
    waveId,
    settings,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const tooltipId = `wave-notification-muted-${waveId}`;
  const t2 = compact ? "tw-inline-flex" : "tw-w-full";
  const t3 = `tw-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-text-[13px] tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-iron-300 ${compact ? "tw-size-9 tw-gap-0 tw-px-0" : "tw-h-10 tw-w-full tw-gap-2 tw-px-3 lg:tw-h-9"}`;
  let t4;
  if ($[0] !== compact || $[1] !== settings.muteLoading) {
    t4 = settings.muteLoading ? <Spinner dimension={14} /> : <><FontAwesomeIcon icon={faBellSlash} className="tw-size-4 tw-flex-shrink-0" />{!compact && <span>Muted</span>}</>;
    $[0] = compact;
    $[1] = settings.muteLoading;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== settings.muteLoading || $[4] !== settings.muteTooltip || $[5] !== settings.onMuteClick || $[6] !== t3 || $[7] !== t4 || $[8] !== tooltipId) {
    t5 = <button disabled={settings.muteLoading} onClick={settings.onMuteClick} data-tooltip-id={tooltipId} data-tooltip-content={settings.muteTooltip} className={t3} aria-label="Unmute wave">{t4}</button>;
    $[3] = settings.muteLoading;
    $[4] = settings.muteTooltip;
    $[5] = settings.onMuteClick;
    $[6] = t3;
    $[7] = t4;
    $[8] = tooltipId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== tooltipId) {
    t6 = <MyStreamActionTooltip id={tooltipId} />;
    $[10] = tooltipId;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}